import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  rate: {},
  errorRate: false,
  isLoadingRate: false,

  rateDetail: {},
  errorRateDetail: false,
  isLoadingRateDetail: false,

  postRate: {},
  errorPostRate: false,
  isLoadingPostRate: false,
  rateDashboard: {},
  errorRateDashboard: false,
  isLoadingRateDashboard: false,
  skipRate: {},
  errorSkipRate: false,
  isLoadingSkipRate: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/rate/index.js